import StandardEdge from "components/Flow/Edges/StandardEdge";

export const edgeTypes = {
  standardEdge: StandardEdge,
};
